import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["icon", "prefixCls", "type", "className", "size", "rounded", "children", "role", "tabIndex", "value", "onClick"];
import * as React from 'react';
import ClassNames from 'classnames';
import { KEY_VALUES } from '../utils';
var Badge = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _ClassNames;
  var icon = props.icon,
    customizePrefixCls = props.prefixCls,
    _props$type = props.type,
    type = _props$type === void 0 ? 'primary' : _props$type,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    _props$rounded = props.rounded,
    rounded = _props$rounded === void 0 ? false : _props$rounded,
    children = props.children,
    role = props.role,
    tabIndex = props.tabIndex,
    value = props.value,
    onClick = props.onClick,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var prefixCls = customizePrefixCls ? customizePrefixCls + "-badge" : 'ap-badge';
  var isRounded;
  if (typeof value === 'string') {
    if (!value) {
      isRounded = false;
    } else if (/[^\x00-\xff]/.test(value) && !icon) {
      isRounded = value.length <= 1;
    } else if (!icon) {
      isRounded = value.length <= 2;
    }
  }
  var clickable = role === 'button' || role === 'link';
  var classNames = ClassNames(prefixCls, className, (_ClassNames = {}, _ClassNames[prefixCls + "-" + type] = type, _ClassNames[prefixCls + "-" + size] = size, _ClassNames[prefixCls + "-round"] = isRounded || rounded, _ClassNames.gesture = clickable, _ClassNames));
  var onkeydown = function onkeydown(event) {
    var key = event.key;
    if ((KEY_VALUES.ENTER === key || KEY_VALUES.SPACE === key) && role === 'button' || KEY_VALUES.ENTER === key && role === 'link') {
      onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }
  };
  var classNameIcon = ClassNames('Appkit4-icon', icon);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: classNames,
    role: role,
    tabIndex: clickable ? 0 : tabIndex,
    onClick: clickable ? onClick : undefined,
    onKeyDown: clickable ? onkeydown : undefined
  }, restProps), icon ? /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, typeof icon === 'string' ? /*#__PURE__*/React.createElement("span", {
    className: classNameIcon
  }) : icon) : null, /*#__PURE__*/React.createElement("span", {
    className: "ap-badge-text"
  }, value));
});
Badge.displayName = 'Badge';
Badge.defaultProps = {
  type: 'primary',
  size: 'medium',
  rounded: false
};
export default Badge;